import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './ProductDetail.css';

const serviceProjects = {
  'archviz-hq': {
    title: 'ArchViz High Quality',
    projects: [
      {
        slug: 'dasnac',
        title: 'DASNAC',
        img: '/img/products/archviz-hq/dasnac/1.jpg',
      },
    ],
  },
  'vr-aided-build': {
    title: 'VR Aided Build',
    projects: [
      {
        slug: 'asf-vrbuilder',
        title: 'ASF Insignia Experience Centre',
        img: '/img/products/vr-builder/asf/1.jpg',
        client: 'ASF Insignia',
        tasks: 'Design',
        location: 'Gwal Pahari, Gurgaon',
        type: 'Experience Centre',
        area: '5,000 sqft',
        status: 'On site',
      },
      // {
      //   slug: 'bmr-vrbuilder',
      //   title: 'BMR Advisors',
      //   img: '/img/products/vr-builder/bmr/1.jpg',
      //   client: 'BMR Advisors',
      //   tasks: 'Design & Build',
      //   location: 'Prestige Nebula, Infantry Road, Bengaluru',
      //   type: 'Commercial Interiors',
      //   area: '25,000 sqft',
      //   status: 'Completed',
      // },
      {
        slug: 'hill-international-vrbuilder',
        title: 'Hill International',
        img: '/img/products/vr-builder/hill-international/1.jpg',
        client: 'Hill International',
        tasks: 'Design & Build',
        location: 'DLF Cyber City, Gurgaon',
        type: 'Commercial Interior',
        area: '5,000 sqft',
        status: 'Completed',
      },
      {
        slug: 'indigo-vrbuilder',
        title: 'IFLY-INDIGO',
        img: '/img/products/vr-builder/indigo/1.jpg',
        client: 'IndiGo',
        tasks: 'Design and Build',
        location: 'Sector 44, Gurgaon',
        type: 'Commercial Interiors',
        area: '85,000 sqft',
        status: 'Completed',
      },
      {
        slug: 'interOcean-vrbuilder',
        title: 'InterOcean Shipping',
        img: '/img/products/vr-builder/interocean/1.jpg',
        client: 'InterOcean Shipping',
        tasks: 'Design',
        location: 'MCIE, Delhi',
        type: 'Commercial Interiors',
        area: '50,000 sqft',
        status: 'On site',
      },
      {
        slug: 'quikr-vrbuilder',
        title: 'Quikr',
        img: '/img/products/vr-builder/quikr/1.jpg',
        client: 'Quikr',
        tasks: 'Design and Build',
        location: 'Rachanahalli, Bengaluru',
        type: 'Commercial Interior & Campus Upgradation',
        area: '1,00,000 sqft',
        status: 'On going',
      },
      {
        slug: 'quint1-vrbuilder',
        title: 'Quint 1',
        img: '/img/products/vr-builder/quint1/1.jpg',
        client: 'Quint 1',
        tasks: 'Concept, Design & Development',
        location: 'Noida',
        type: 'Commercial Interiors',
      },
      {
        slug: 'quint2-vrbuilder',
        title: 'Quint 2',
        img: '/img/products/vr-builder/quint2/1.jpg',
        client: 'Quint 2',
        tasks: 'Design & Build',
        location: 'Noida',
        type: 'Commercial Interiors',
      },
      {
        slug: 'quint3-vrbuilder',
        title: 'Quint 3',
        img: '/img/products/vr-builder/quint3/1.jpg',
        client: 'Quint 3',
        tasks: 'Design & Build',
        location: 'Noida',
        type: 'Commercial Interiors',
      },
      {
        slug: 'bloomberg-quint-vrbuilder',
        title: 'Bloomberg Quint',
        img: '/img/products/vr-builder/bloomberg-quint/1.jpg',
        client: 'Bloomberg Quint',
        tasks: 'Design & Build',
        location: 'India Bulls',
        type: 'Commercial Interiors',
      },
    ],
  },
};

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = serviceProjects[slug];

  if (!service) {
    return (
      <>
        <Navbar />
        <main className="pd-container container">
          <h2>Service not found</h2>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="pd-container container">
        <ol className="nav-path">
          <li><Link to="/">Home</Link><span> &gt; </span></li>
          <li><Link to="/services">Services</Link><span> &gt; </span></li>
          <li>{service.title}</li>
        </ol>

        <h2 className="portfolio-header header-shadow text-center">{service.title}</h2>

        <div className="product-grid services-grid">
          {service.projects.map((project, i) => (
            <div className="product-card" key={i}>
              {/* ✅ FIXED: Link now uses slug only */}
              <Link to={`/services/${slug}/${project.slug}`}>
                <div
                  className="cover-img"
                  style={{
                    backgroundImage: `url(${project.img})`,
                    height: '180px',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
                <h4 className="text-center">{project.title}</h4>
                <div className="meta-info">
                  {project.client && <span><strong>Client:</strong> {project.client}</span>}
                  {project.tasks && <span><strong>Tasks:</strong> {project.tasks}</span>}
                  {project.location && <span><strong>Location:</strong> {project.location}</span>}
                  {project.type && <span><strong>Type:</strong> {project.type}</span>}
                  {project.area && <span><strong>Area:</strong> {project.area}</span>}
                  {project.status && <span><strong>Status:</strong> {project.status}</span>}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}
